// extracted by mini-css-extract-plugin
export default {"titleContainer":"ContactsList_titleContainer__H5q9r","list":"ContactsList_list__IenvM","name":"ContactsList_name__S5ifN","infosContainer":"ContactsList_infosContainer__xCBcf"};